export default __webpack_public_path__ + "static/media/FuturaPT-Book.59b62ef8.woff2";